import React, {useEffect, useRef, useState} from "react";
import {SitePages} from "../SitePages";
import {GoToPageButton} from "../components/goToPageButton";
import {IFrames, Images, Videos} from "../AssetReferences";
import {BackgroundVideo} from "../components/backgroundVideo";
import {AdditionalElement} from "../components/additional_element";
import {AdditionalElementIDs} from "./front_page_data";
import style from "./front_page_styles.module.css";
import s from "./cybershore_meditations/cybershore_game.module.css";
import UnityIFrame, {Rectum} from "../components/unityIFrame";
import {useNavigate} from "react-router-dom";

export default function NavigationPage({}) {
    const navigate = useNavigate();
    function openPage(page) {
        navigate("/" + page)
    }    

    return (
        <>
            <div style={{textAlign: "center"}}>
                <GoToPageButton destination={SitePages.MobilePopup} text={"Go to Mobile Redirect"} onPageOpen={openPage}/>
                <GoToPageButton destination={SitePages.FrontPage} text={"Go to Front Page"} onPageOpen={openPage}/>
                <br/>
                <GoToPageButton destination={SitePages.MicrobialSexLoops} text={"Go to Microbial Sex Loops"} onPageOpen={openPage}/>
                <GoToPageButton destination={SitePages.MicrobialSexVideoComic} text={"Go to Toi Videos"} onPageOpen={openPage}/>
                <GoToPageButton destination={SitePages.CybershoreMeditations} text={"Go to Toi Game"} onPageOpen={openPage}/>
                <GoToPageButton destination={SitePages.DecaySim} text={"Go to George page"} onPageOpen={openPage}/>
            </div>
            
        </>

    )
}
